/*
 * @Author: 赵泽文
 * @Date: 2022-03-08 14:35:49
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-07-18 15:35:54
 * @Description: 收货单数据存储
 */

import type {
  IReceiveOrderModel,
  IReceiveOrderStore,
} from '@monorepo/types/purchasing/receiveOrder/receiveOrder.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IReceiveOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
  },
  auditNo: '',
  total_money: '0',
  total_use_unit_qty: '0',
};

const receiveOrderStore: IReceiveOrderModel = {
  namespace: 'receiveOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default receiveOrderStore;
